module.exports = {"view":{"noEvents":"No events found","showSuccess":"Show success messages","showErrors":"Show error messages","download":"Download"}}